import { render, staticRenderFns } from "./HomePostagens.vue?vue&type=template&id=a6f95a7e&scoped=true"
import script from "./HomePostagens.vue?vue&type=script&lang=js"
export * from "./HomePostagens.vue?vue&type=script&lang=js"
import style0 from "./HomePostagens.vue?vue&type=style&index=0&id=a6f95a7e&prod&lang=scss&scoped=true"
import style1 from "./HomePostagens.vue?vue&type=style&index=1&id=a6f95a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f95a7e",
  null
  
)

export default component.exports